import { Fragment } from 'react';
import type { FC } from 'react';
import * as Styled from './styled';
import type { LanguageSelectorProps } from './types';

export * from './types';

export const LanguageSelector: FC<LanguageSelectorProps> = (props) => {
  const { color = 'dark', languageSelectorButtons, ...rest } = props;

  if (!languageSelectorButtons.length) {
    return null;
  }
  return (
    <Styled.Wrapper color={color} {...rest}>
      {languageSelectorButtons.map((btn, key) => (
        <Fragment key={`${btn.label}-${key}`}>
          <Styled.LanguageButton
            onClick={btn.onClick}
            selected={btn.selected}
            onDoubleClick={btn.onDoubleClick}
          >
            {btn.label}
          </Styled.LanguageButton>
          {!!languageSelectorButtons[key + 1] && <Styled.Seperator>-</Styled.Seperator>}
        </Fragment>
      ))}
    </Styled.Wrapper>
  );
};
